export const createAccountStore = defineStore('createAccount', () => {
  const config = useRuntimeConfig()

  const formId = ref<string>(config.public.createAccountFormId as string)

  const setFormId = (newFormId: string) => {
    formId.value = newFormId
  }

  return { formId, setFormId }
})
